import { useEffect, useRef } from 'react';
import { useScrollIntoView } from '../../../../../hooks/useScrollIntoView';
import { IPoiItem } from '../../../domain/models/IPoiItem';
import { usePagination } from './usePagination';

export const usePaginationWithScroll = (data: IPoiItem[]) => {
	const { ref, scrollIntoView } = useScrollIntoView(230);
	const firstRender = useRef(true);

	const { slicedPoiData, totalPages, currentPageIndex, setCurrentPageIndex } =
		usePagination(data);

	useEffect(() => {
		// Prevent page scroll on first render
		if (!firstRender.current) {
			scrollIntoView();
		}
		firstRender.current = false;
	}, [currentPageIndex]);

	return {
		ref,
		slicedPoiData,
		totalPages,
		currentPageIndex,
		setCurrentPageIndex,
	};
};
